import { render, staticRenderFns } from "./Box7.vue?vue&type=template&id=4175c23c&scoped=true&"
import script from "./Box7.vue?vue&type=script&lang=js&"
export * from "./Box7.vue?vue&type=script&lang=js&"
import style0 from "./Box7.vue?vue&type=style&index=0&id=4175c23c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4175c23c",
  null
  
)

export default component.exports